import Vue from 'vue';

const state = {
  units: {}
}

const getters = {

  unit (state) {
    return id => {
      if (id in state.units) return state.units[id];
      else return false;
    }
  },

  units (state) {
    return state.units;
  }
}

const mutations = {

  storeUnits (state, units) {
    
    units.forEach(unit => {
      var current = state.units[unit._id] || {};
      Vue.set(state.units, unit._id, {
        ...current,
        ...unit
      });
    });
  },

  removeUnit (state, id) {
    if (id in state.units) Vue.delete(state.units, id);
  },

  clearUnits () {
    Vue.set(state, 'units', {});
  }

}

const actions = {
  
  loadUnits ({commit}, params) {
    
    var filters = params.filters || {};

    if (!params.company) {
      return Promise.reject('state.unit - loading Units - Missing required param "company"');
    }

    var queryParams = {
      ...filters,
      ...{
        populateProperty: true,
        populateType: true
      }
    };

    return window.server.getReq('company/' + params.company + '/units', {
      params: queryParams
    })
    .then(data => {
      var result = storeData(data);
      commit('storeUnits',      result.units);
      commit('storeUnitTypes',  result.unitTypes);
      // commit('storeProperties', result.properties);
      return Promise.resolve(result.units);
    })  
    .catch(e => {
      return Promise.reject(e);
    });

  },

  loadUnit ({commit}, params) {
    
    var filters = params.filters || {};

    if (!params.unit) {
      return Promise.reject('state.unit - loading Unit - Missing required param "unit"');
    }

    var queryParams = {
      ...filters,
      ...{
        populateProperty: true,
        populateType: true
      }
    };

    return window.server.getReq('unit/' + params.unit, {
      params: queryParams
    })
    .then(data => {
      var result = storeData([data]);
      commit('storeUnits',      result.units);
      commit('storeUnitTypes',  result.unitTypes);
      // commit('storeProperties', result.properties);
      return Promise.resolve(result.units[0]);
    })  
    .catch(e => {
      return Promise.reject(e);
    });

  },

  loadUnitRoles ({commit}, params) {

    var filters = params.filters || {};

    if (!params.unit) {
      return Promise.reject('state.unit - loading Unit Roles - Missing required param "unit"');
    }

    var queryParams = {
      ...filters,
      ...{
        populateRoles: false
      }
    };

    return window.server.getReq('unit/' + params.unit + '/users', {
      params: queryParams
    })
    .then(data => {
      commit('storeUsers', data);
      return Promise.resolve(data);
    })  
    .catch(e => {
      return Promise.reject(e);
    });
    
  },

  createUnit ({commit, dispatch}, params) {
    if (!params.unit) {
      return Promise.reject('state.unit - Create Unit - Missing required param "unit"', params);
    }

    return window.server.postReq('property/' + params.unit.property + '/unit', {
      unit: params.unit
    })
    .then(data => {

      return dispatch('loadUnit', { unit: data._id });
    })
    .catch(e => {
      return Promise.reject(e);
    });
  },

  updateUnit ({commit, dispatch}, params) {
    if (!params.unit) {
      return Promise.reject('state.unit - update Unit - Missing required param "unit"', params);
    }

    return window.server.putReq('property/' + params.unit.property + '/unit/' + params.unit._id, {
      unit: params.unit
    })
    .then(data => {

      return dispatch('loadUnit', { unit: params.unit._id });
    })
    .catch(e => {
      return Promise.reject(e);
    });
  },

  deleteUnit ({commit}, params) {
    
    if (!params.unit) {
      return Promise.reject('state.unit - Deleting Unit - Missing required param "unit"');
    }
    else if (!params.property) {
      return Promise.reject('state.unit - Deleting Unit - Missing required param "property"');
    }

    return window.server.delReq('property/' + params.property + '/unit/' + params.unit, { })
    .then(data => {

      commit('removeUnit', params.unit);
      return Promise.resolve(data);
    })
    .catch(e => {
      return Promise.reject(e);
    });
  },
  
};

function storeData (units) {

  // Break out and store what we can
  var properties  = {};
  var unitTypes   = {};
  
  units.forEach((unit, i) => {
    
    if (!(unit.property._id in properties)) {
      properties[unit.property._id] = unit.property;
    }
    
    units[i].property = unit.property._id;

    if (!(unit.type._id in unitTypes)) unitTypes[unit.type._id] = unit.type;
    units[i].type = unit.type._id;
  }); 

  properties  = _.values(properties);
  unitTypes   = _.values(unitTypes);

  return {
    properties,
    unitTypes,
    units
  };
};

export default {
  state,
  getters,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/unit.js